/**
 * @generated SignedSource<<2616cb81970234a0ea56e46297406ba0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanupStorage_data$data = {
  readonly diskCleanerScan?: {
    readonly storage: {
      readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupResult_cleanInfo">;
    } | null;
  };
  readonly " $fragmentType": "DiskCleanupStorage_data";
};
export type DiskCleanupStorage_data$key = {
  readonly " $data"?: DiskCleanupStorage_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupStorage_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    },
    {
      "kind": "RootArgument",
      "name": "scan"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./DiskCleanupStorageRefetchQuery.graphql')
    }
  },
  "name": "DiskCleanupStorage_data",
  "selections": [
    {
      "condition": "scan",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "input",
              "variableName": "input"
            }
          ],
          "concreteType": "DiskCleanerResult",
          "kind": "LinkedField",
          "name": "diskCleanerScan",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CleanInfo",
              "kind": "LinkedField",
              "name": "storage",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DiskCleanupResult_cleanInfo"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "637249e67e5755709c0236af7cd13e75";

export default node;
